<template>
  <div>
    {{ arrival }}
  </div>
</template>

<script>
import {formatDT} from '../utils'

export default {
  name: 'CalcFlightsTableCellArrival',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    arrival () {
      return formatDT(this.row.arrival)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcFlightsTableCellArrival.vue